module.exports = __webpack_public_path__ + "img/ic_rego.0e6b8969.svg";